/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3daefe43cec773a2fb871690e8bfbca9>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "StarUnstarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const StarUnstarredIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="m6 8.917.424-.619L6 8.008l-.424.29zM2.597 11.25l-.724-.194a.75.75 0 0 0 1.148.813zm1.07-3.986.724.194.124-.463-.368-.307zM.75 4.834l-.058-.748A.75.75 0 0 0 .27 5.41zm3.792-.292.057.747.473-.036.17-.442zM6 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.458 3.792-.7.269.17.442.473.036zm3.792.291.48.577a.75.75 0 0 0-.423-1.324zm-2.917 2.43-.48-.575-.368.307.124.463zm1.07 3.987-.424.618a.75.75 0 0 0 1.148-.812zM5.576 8.298l-3.403 2.334.848 1.236 3.403-2.333zm-2.254 3.146L4.39 7.458 2.942 7.07l-1.07 3.986zm.825-4.756L1.23 4.258.27 5.41l2.917 2.43zM.807 5.58 4.6 5.29l-.115-1.495-3.792.292zm4.435-.77L6.7 1.019 5.3.481 3.842 4.272zM5.3 1.019l1.458 3.792 1.4-.539L6.7.481zm2.1 4.27 3.793.292.114-1.495-3.791-.292zm3.37-1.032-2.917 2.43.96 1.153 2.917-2.43zM7.609 7.458l1.07 3.986 1.448-.388-1.07-3.986zm2.218 3.174L6.424 8.298l-.848 1.237 3.403 2.333z"/>`,
  type: 'utility'
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var _default = exports.default = StarUnstarredIcon;